import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {Menu, X, Phone} from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/coverage", label: "Coverage" },
    { path: "/faq", label: "FAQ" },
    { path: "/blog", label: "Blog" },
    { path: "/contact", label: "Contact" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="bg-black border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-2xl font-bold">
              <span className="text-white">DRAG CAR</span>
              <span className="text-[#DC0000]"> INSURANCE</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? "text-[#DC0000]"
                    : "text-gray-300 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:1-800-DRAG-CAR"
              className="flex items-center space-x-2 text-sm font-medium text-gray-300 hover:text-white transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span>1-800-DRAG-CAR</span>
            </a>
            <Link
              to="/contact"
              className="bg-[#DC0000] text-white px-6 py-2.5 rounded-md font-semibold hover:bg-red-700 transition-all transform hover:scale-105"
            >
              Get a Quote
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-[#1a1a1a] border-t border-gray-800">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block py-2 text-base font-medium ${
                  isActive(link.path)
                    ? "text-[#DC0000]"
                    : "text-gray-300 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:1-800-DRAG-CAR"
              className="flex items-center space-x-2 py-2 text-base font-medium text-gray-300 hover:text-white"
            >
              <Phone className="w-4 h-4" />
              <span>1-800-DRAG-CAR</span>
            </a>
            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              className="block w-full bg-[#DC0000] text-white px-6 py-3 rounded-md font-semibold text-center hover:bg-red-700 transition-colors"
            >
              Get a Quote
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
